/* Package JSON Import will be here */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import classNames from "classnames";
import { bindActionCreators } from "redux";
import { Badge } from "antd";
import { Image } from 'antd';
/* Package JSON Import will be here */

/* Project Import will be here */
import SearchProducts from "./SearchProducts";
import { appRoutesConst, navigateToProductList, navigateToCart } from "app/navigation";
import TooltipComp from "components/reusable/TooltipComp";
import logo from "assets/img/logo-icon.png";
/* Project Import will be here */

class MobileCategoryMenu extends Component {
  renderMobileNav = () => {
    const { notifications, cart, appSettings, router, translate } = this.props;
    let path = router.location.pathname;
    const backDisabledPaths = [appRoutesConst.home];
    const shouldShowBackIcon = backDisabledPaths.includes(path);

    return (
      <nav className="navbar mobile-nav navbar-expand-lg nav-sm pd-l-r-5">
        <div className="d-flex flex-row align-items-center justify-content-between pd-0-15 mob-header-height">
          {/* Hamburger menu */}
          {(path !== appRoutesConst.orderSummary) &&
            <div className="nav-link nav-link-drawer-menu-padding mt-1 ">
              <i onClick={this.props.openDrawerMenu} className="fa fa-bars fa-lg fav-product-header-icon cursor-pointer" aria-hidden="true"></i>
            </div>
          }

          {/* Back button */}
          {!shouldShowBackIcon &&
            <div className="nav-link nav-link-drawer-menu-padding mt-1 ">
              <TooltipComp title={translate("common.buttons.back")}>
                <i className="fa fa-chevron-left ml-1 mr-1 font-15 cursor-pointer color-white" aria-hidden="true" onClick={this.props.handleGoBack}></i>
              </TooltipComp>
            </div>
          }

          {/* Client logo */}
          <div className="d-flex align-items-center mobile-logo-block">
            {(path === appRoutesConst.orderSummary) ?
              <div className="navbar-brand">
                <Image
                  className="client-image-height"
                  src={window.logoUrl + 'headerlogo.png'}
                  alt={translate("common.imageAlt.headerLogo")}
                  fallback={logo}
                  preview={false}
                />
              </div>
              :
              <Link to={appSettings.isEnableHomePage ? appRoutesConst.home : appRoutesConst.productList} className="navbar-brand">
                {/* Client logo */}
                <Image
                  className="client-image-height"
                  src={window.logoUrl + 'headerlogo.png'}
                  alt={translate("common.imageAlt.headerLogo")}
                  fallback={logo}
                  preview={false}
                />
              </Link>
            }
          </div>

          {/* Menu icons */}
          <div>
            {(path !== appRoutesConst.orderSummary) &&
              <ul className="navbar-nav flex-row justify-content-end align-items-center">
                {/* Favourite product heart icon */}
                {(appSettings.isFavProductEnable) &&
                  <li className="nav-item mt-1">
                    <Link to={appRoutesConst.favProducts} className="nav-link">
                      <i className="fa fa-heart fa-lg" aria-hidden="true"></i>
                    </Link>
                  </li>
                }

                {(appSettings.isShowNotifications) &&
                  <li className="nav-item cart__link--content mt-1">
                    <Link to={appRoutesConst.notification} className="nav-link">
                      <Badge count={notifications.count} overflowCount={99} offset={[5, -5]} className="custom-badge-header">
                        <i className={classNames('fa fa-bell fa-lg', { 'animate-ring': notifications.count > 0 })} aria-hidden="true"></i>
                      </Badge>
                    </Link>
                  </li>
                }

                <li className="nav-item cart__link--content">
                  <Badge count={cart.ids.length + cart.freeProducts.length} overflowCount={99} offset={[5, -1]} className="custom-badge-header">
                    <Link to={appRoutesConst.orderSummary} className="nav-link">
                      <i className="fa fa-cart-arrow-down font-22  fa-lg" aria-hidden="true"></i>
                    </Link>
                  </Badge>
                </li>
              </ul>
            }
          </div>

          {/* Search product menu */}
          {(path !== appRoutesConst.orderSummary) &&
            <SearchProducts />
          }
        </div>
      </nav>
    );
  };

  render() { return this.renderMobileNav(); }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications,
  cart: state.cart,
  router: state.router,
  appSettings: state.appSettings,
  retailer: state.localStore.user,
  translate: getTranslate(state.locale),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      navigateToProductList,
      navigateToCart
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MobileCategoryMenu));